import { onlineSignupsEnabled } from "./signupEnablement";

export const payNowEnabledFromAccount = (row) =>
  Boolean(row?.stripeAccountId && row?.cardPaymentsActive);

export const readPayNowStatusPayload = (payload, error) => {
  if (error) {
    return {
      known: false,
      payNowEnabled: null,
      error: error.message || "Could not check card payments.",
    };
  }
  if (!payload || typeof payload.payNowEnabled !== "boolean") {
    return {
      known: false,
      payNowEnabled: null,
      error: payload?.error || "Could not check card payments.",
    };
  }
  return {
    known: true,
    payNowEnabled: payload.payNowEnabled,
    error: null,
  };
};

/** Pay now only when org Card payments is active. Signups on does not turn this on. */
export const payNowOffered = (payNowEnabled) => payNowEnabled === true;

/**
 * Creating a signup does not require Stripe Connect / Card payments.
 * Card payments Not started still allows the desk / Due path.
 * Same rule as Registration Open / onlineSignupsEnabled.
 */
export const signupCreateAllowed = (settings = {}) =>
  onlineSignupsEnabled(settings);

/**
 * Payment required to hold blocks Pay at the desk only when Pay now is actually on.
 * When Card payments is off or unknown, Cart can still close at the desk.
 */
export const deskCloseoutOffered = ({
  payNowEnabled,
  paymentRequiredToHold,
} = {}) => !(Boolean(paymentRequiredToHold) && payNowOffered(payNowEnabled));

